import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type StatusVariant = "neutral" | "success" | "warning" | "error" | "accent" | "live";

export interface StatusProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: StatusVariant;
  children?: ReactNode;
}

export const Status = ({ variant = "neutral", className, children, ...rest }: StatusProps) => (
  <span
    className={cn("hui-status", variant !== "neutral" && `hui-status--${variant}`, className)}
    {...rest}
  >
    <span className="hui-status__dot" aria-hidden />
    <span>{children}</span>
  </span>
);
